<template>
  <Slide class="ProspectDetailsSalesSlide"
    v-bind="{ isCurrentSlide, isStartingSlide, mayContinue }"
    :title="content.title"
    nextAction="nextSlide"
  >
    <InputFields @input="doUpdateField" @change="doUpdateField">
      <TextInput v-if="fieldConfig.firstName.present"
        name="firstName"
        :title="content.firstNameLabel"
        :value="fieldValues.firstName"
        :error="fieldErrors.firstName"
        :optional="!fieldConfig.firstName.required"
        :disabled="!isCurrentSlide"
      />
      <TextInput v-if="fieldConfig.lastName.present"
        name="lastName"
        :title="content.lastNameLabel"
        :value="fieldValues.lastName"
        :error="fieldErrors.lastName"
        :optional="!fieldConfig.lastName.required"
        :disabled="!isCurrentSlide"
      />
      <TextInput v-if="fieldConfig.company.present"
        name="company"
        :title="content.companyLabel"
        :value="fieldValues.company"
        :error="fieldErrors.company"
        :optional="!fieldConfig.company.required"
        :disabled="!isCurrentSlide"
      />
      <TextInput v-if="fieldConfig.jobTitle.present"
        name="jobTitle"
        :title="content.jobTitleLabel"
        :value="fieldValues.jobTitle"
        :error="fieldErrors.jobTitle"
        :optional="!fieldConfig.jobTitle.required"
        :disabled="!isCurrentSlide"
      />
      <TextInput v-if="fieldConfig.noOfEmployees.present"
        name="noOfEmployees"
        :title="content.noOfEmployeesLabel"
        :value="fieldValues.noOfEmployees"
        :error="fieldErrors.noOfEmployees"
        :optional="!fieldConfig.noOfEmployees.required"
        :disabled="!isCurrentSlide"
      />
      <RegionInput v-if="fieldConfig.region.present"
        name="region"
        :title="content.regionLabel"
        :placeholder="content.regionPlaceholder"
        :value="fieldValues.region"
        :error="fieldErrors.region"
        :optional="!fieldConfig.region.required"
        :disabled="!isCurrentSlide"
      />
    </InputFields>
  </Slide>
</template>

<script>
import getCountryData from '../../../lib/countryData.js'
import { inputFieldsSlideMixin } from '../util/slideBuilders.js'

import InputFields from './elems/InputFields.vue'
import RegionInput from './elems/RegionInput.vue'
import Slide from './elems/Slide.vue'
import TextInput from './elems/TextInput.vue'

export default {
  mixins: [inputFieldsSlideMixin],
  components: {
    InputFields,
    RegionInput,
    Slide,
    TextInput,
  },
  inject: ['locale'],
  computed: {
    fieldConfig() {
      const fallbackLocale = this.locale
      const countryData = getCountryData(fallbackLocale)
      return {
        firstName: {
          present: true,
          required: true,
        },
        lastName: {
          present: true,
          required: true,
        },
        company: {
          present: true,
          required: true,
        },
        jobTitle: {
          present: true,
          required: true,
        },
        noOfEmployees: {
          present: this.formOptions.brand === 'inseego',
          required: false,
        },
        region: {
          present: Boolean(countryData?.regions),
          required: true,
        },
      }
    },
  },
}
</script>
